export default __webpack_public_path__ + "static/pwc-helvetica-neue-400-189fb735e57c12dbab99b9f97686e8be.woff";